export default {
	title: "",
	subtitle: "Listing Bank Transfers (Wires)",
  path: "bank_transaction_wires_list",
	paragraphs: [
    "Return the bank transfers list",
    "Example: You can use the endpoint '/wires?last_id=a5c69e9e-8d84-4b0b-9af8-dcfb5be35093&per_page=1'.",
    "This will return the last wire after the transaction with ID a5c69e9e-8d84-4b0b-9af8-dcfb5be35093.",
  ],
	request: {
		method: "GET", 
		endpoint: "/wires",
     responses:{
        "data": [
              {
            "value": "574.84",
            "unretryable": null,
            "to_bank_account": {
                "routing_number": null,
                "pix_info": null,
                "owner_name": "André Freitas Lopes",
                "owner_document_type": null,
                "owner_document_number": "01472583691",
                "nickname": null,
                "intermediary_bank_account": null,
                "id": "102518ca-5d8a-443f-b131-e47d99bc4d0d",
                "iban": null,
                "currency": "BRL",
                "company": {
                    "social_name": "John Doe",
                    "phone_number": "99812-1212",
                    "id": "01e0725b-b4f5-46b1-811a-a3cbcb314d10",
                    "fiscal_country": "BR",
                    "document_type": "cpf",
                    "document_number": "05069869183",
                    "company_name": "Company & CIA"
                },
                "branch_number": "0031",
                "branch_country": "BR",
                "bank": {
                    "swift": null,
                    "name": "Código Banco Beg S.A.",
                    "ispb": null,
                    "id": "f9dcd833-a4a8-4595-8f5a-b63b0a98292d",
                    "country": "BRA",
                    "code": "031"
                },
                "account_type": "conta-corrente",
                "account_number": "85296",
                "aba": null
            },
            "status": "success",
            "inserted_at": "2025-02-05T16:25:07.062903",
            "id": "e027fc20-42d0-4da6-92d8-60893509b531",
            "currency": "BRL"
        }
        ]
    }
	},
  queryPayload: [
    {
      name: "last_id",
      type: "string",
      required: false,
      description: "Last transaction UUID for pagination"
    },
    {
      name: "per_page",
      type: "string",
      required: false,
      description: "Number of elements per page"
    },
    {
      name: "pending",
      type: "boolean",
      required: false,
      description: "Filter only transactions that are pending"
    },
    {
      name: "from",
      type: "iso datetime",
      required: false,
      description: "Filter from date/time, e.g.: 2022-05-01T03%3A00%3A00.000Z"
    },
    {
      name: "to",
      type: "iso datetime",
      required: false,
      description: "Filter to date/time, e.g.: 2022-05-30T03%3A00%3A00.000Z"
    },
    {
      name: "company_id",
      type: "string",
      required: false,
      description: "Filter by partner (company) UUID"
    },
    {
      name: "subject_id",
      type: "string",
      required: false,
      description: "Filter by subject UUID"
    },
    {
      name: "transaction_type",
      type: "string",
      required: false,
      description: "Filter by transaction type automatic or manual"
    },
    {
      name: "currency",
      type: "string",
      required: false,
      description: "Filter to match only the selected currency"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/BankTransfersWiresList.js